<div class="flex flex-col">
  @for (i of rowsArray(); track i) {
  <div class="flex items-center gap-3 px-4 py-3">
    <div class="size-9 rounded-lg overflow-hidden shrink-0"><dss-libs-ui-skeleton /></div>
    <div class="flex flex-col gap-1.5 flex-1 min-w-0">
      <div class="h-3.5 w-32 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
      <div class="h-3 w-20 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
    @if (showTrailing()) {
    <div class="h-5 w-16 rounded-full overflow-hidden shrink-0"><dss-libs-ui-skeleton /></div>
    }
  </div>
  }
</div>
